// extracted by mini-css-extract-plugin
module.exports = {"copyTooltip":"CopyTooltip_copyTooltip__K4zTV"};